import { ReportsApiClient } from '@fourthwall/services/dist/ReportsApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useAnalyticsReportsDefinitionsQuery = createQueryHook(
  ReportsApiClient.getReportsDefinitions,
  {
    queryKey: ['analyticsReportsDefinitions'],
  },
)
